import React, { useCallback } from 'react';
import { CommentResponse } from '../../../../types/api/comments';
import { PostResponse } from '../../../../types/api/forum';
import { formatDate, formatTime } from '../../../../helpers/dates';
import { UserHeaderCard } from '../../../basic/UserHeaderCard';
import MediaPreview from '../../../common/MediaPreview';
import { Stack, Text } from '@primer/react'
import { ClockIcon, CalendarIcon } from '@primer/octicons-react';

interface CommentCardProps {
    comment: CommentResponse | undefined
    post: PostResponse | undefined
}

export const CommentCard: React.FC<CommentCardProps> = ({ comment, post }) => {

    const user = comment?.author ?? comment?.user ?? post?.user
    const content = comment?.content ?? post?.content
    const createdAt = comment?.createdAt ?? post?.createdAt
    const media = comment?.media ?? post?.media

    return (
        <div>
            <Stack justify="space-between" direction="horizontal">
                {user && (
                    <UserHeaderCard
                        user={user}
                        isLarge={true}
                        isSupport={false}
                        onClick={() => { }}
                    />
                )}
            </Stack>
            <Stack gap='none' className='ml-[52px] mr-4 mb-2'>
                <div>
                    <Text className='text-[14px] text-aloix-grey ml-1 mt-3 break-words'>
                        {content}
                    </Text>
                    {media && <MediaPreview images={media} className='mt-2' />}
                </div>
            </Stack>

            <div className="ml-[56px]">
                <Stack direction="horizontal" gap="normal">
                    <Stack direction="horizontal" align="center" gap="condensed">
                        <CalendarIcon size={16} />
                        <Text className='text-[14px] text-aloix-grey ml-1'>{createdAt && formatDate(createdAt)}</Text>
                    </Stack>
                    <Stack direction="horizontal" align="center" gap="condensed">
                        <ClockIcon size={16} />
                        <Text className='text-[14px] text-aloix-grey ml-1'>{createdAt && formatTime(createdAt)}</Text>
                    </Stack>
                </Stack>
            </div>
        </div>
    )
};